// @flow

import type { State } from "@store/reducers";
import type { AlertShort } from "@modules/shared/reducer/alerts/types";

export const getAlerts = (state: State): Array<AlertShort> => {
  const { list } = state.shared.alerts;
  return list ? list.map(a => ({ id: a.id, name: a.content.details.name })) : [];
};

export const getActiveMonitoringPromptAlerts = (state: State): Array<AlertShort> | null => {
  const alerts = ((state.shared || {}).alerts || {}).list;
  if (!alerts) return null;
  return alerts
    .filter(
      alert =>
        ((alert.content || {}).details || {}).isActive === true &&
        ((alert.content || {}).details || {}).alertPurpose === "MONITORING_PROMPT",
    )
    .map(alert => ({
      id: alert.id,
      name: alert.content.details.name,
    }));
};

export const alertSuppressionIsLoading = (state: State): Array<Object> => {
  return !!state.shared.alertSuppression.requestsInProgress;
};

export const getAlertsSuppressedBy = (state: State): Array<Object> => {
  return state.shared.alertSuppression.alertsSuppressedBy;
};

export const getAlertsSuppression = (state: State): Array<Object> => {
  return state.shared.alertSuppression.alertsSuppression;
};

export const getAlertsSuppressionOptions = (state: State): Array<Object> => {
  return state.shared.alertSuppression.alertsSuppressionOptions;
};
